import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=55f837f5"
import script from "./MapSettings.vue?vue&type=script&lang=js"
export * from "./MapSettings.vue?vue&type=script&lang=js"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=55f837f5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports